import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-240f1452"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule-header" }

import {withDefaults} from "vue";
import {CourseVO} from "@/apis/course";
interface ScheduleHeaderProps {
  courseVO: Partial<CourseVO>
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleHeader',
  props: {
    courseVO: { default: () => ({
    courseName: "默认课程"
  }) }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.courseVO.courseName), 1)
  ]))
}
}

})